import clsx from "clsx"
import React from "react"

interface Props {}

export const JobsDrawerFooterSkeleton: React.FC<Props> = () => {
  return (
    <div className="flex h-full w-full flex-row items-center justify-between">
      <div>
        <div className="h-[30px] w-[100px] animate-pulse bg-bg-2 md:w-[180px]" />
        <div className="mt-2 hidden h-[20px] w-[80px] animate-pulse bg-bg-2 md:flex" />
      </div>
      <div>
        <div className="flex h-[40px] w-[66px] animate-pulse flex-row items-center gap-2 rounded-full bg-bg-2 md:hidden" />
        <div className="hidden h-[56px] w-[100px] animate-pulse flex-row items-center gap-2 rounded-full bg-bg-2 md:flex" />
      </div>
    </div>
  )
}
